import React, { useMemo, useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import { useTranslation } from 'react-i18next';
import { DashboardOutlined } from '@ant-design/icons';
import { findFirstAvailableMenuItem } from 'utils/menuUtils';
import { hasResource } from 'utils/resourceAuth';
import { ResourceCode } from 'constants/resourceCodes';

const MapToolLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const menuItems = useMemo(() => [
        {
            key: 'performance-monitor',
            label: t('mapTool.performanceMonitor.title'),
            icon: <DashboardOutlined />,
            display: hasResource([ResourceCode.menu.PERFORMANCE_MONITOR]),
            onClick: () => navigate('/map-tool/performance-monitor')
        },
    ], [navigate, t]);

    useEffect(() => {
        const isRoot = location.pathname === '/map-tool' || location.pathname === '/map-tool/';
        if (!isRoot) return;
        const first = findFirstAvailableMenuItem(menuItems);
        if (first?.onClick) first.onClick();
    }, [location.pathname, menuItems]);

    return (
        <MainLayout
            activeFirstMenu="map-tool"
            secondMenu={menuItems}
        >
            <div className="p-6 h-full flex flex-col">
                <Outlet />
            </div>
        </MainLayout>
    );
};

export default MapToolLayout;

